import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { MyAuthService } from '../services/auth-service.service';


@Injectable({
  providedIn: 'root',
})
export class VerifiedAccountGuard implements CanActivate, CanLoad, CanActivateChild {
  constructor(
    private authService: MyAuthService,
    private auth0Service: Auth0Service,
    private router: Router
  ) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    return this.auth0Service.isAuthenticated$.pipe(
      take(1),
      map(isAuthenticated => {
        return isAuthenticated ? true : this.router.createUrlTree(['/login']);
      })
    );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.redirectIfUnauthenticated();
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.redirectIfUnauthenticated();
  }

  private redirectIfUnauthenticated(): Observable<boolean | UrlTree> {
    return this.auth0Service.isAuthenticated$.pipe(
      take(1),
      map((isAuthenticated: boolean) => {
        return isAuthenticated ? true : this.router.createUrlTree(['/login']);
      })
    );
  }
}
